export const GTM_AUTH = 'CXsKrbmeizWaaDt3OQhenA';
export const GTM_CONTAINER_ID = 'GTM-MHRX774';
export const GTM_PREVIEW = 'env-2';

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = url => {
  window.gtag('config', GTM_CONTAINER_ID, {
    page_path: url,
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

export const bookingEvent = ({
  step,
  resourcePublicId,
  reservationPublicId,
}) => {
  window.gtag('event', 'booking_rendered', {
    booking_step: step,
    res_id: resourcePublicId,
    rv_id: reservationPublicId,
  });
};

export const purchaseEvent = ({ step, productPublicId, customerPublicId }) => {
  window.gtag('event', 'purchase_rendered', {
    purchase_step: step,
    product_id: productPublicId,
    customer_id: customerPublicId,
  });
};
